<ng-container ngForm>
  <section>
    <tg-row>
      <tg-col>
        <div class="tm-list-photo-management__count p-label">
          Upload photos ({{ (photos || []).length }}/{{ maxPhotos }})
        </div>
      </tg-col>
    </tg-row>
    <tg-row>
      <tg-col>
        <p class="tm-list-photo-management__photo-info">
          @if (photos && photos.length > 0) {
            <span
              class="tm-list-photo-management__hint-text p-secondary-copy"
              >
              Drag to rearrange, or select a photo to edit or
              remove it.
            </span>
          }
        </p>
      </tg-col>
    </tg-row>
    <tg-row
      (cdkDropListDropped)="onDrop($event)"
      aria-label="photos for this listing"
      role="list"
      cdkDropList
      cdkDropListOrientation="mixed"
      >
      @for (photo of photos; track photo.photoId; let i = $index) {
        <tg-col
          [cdkDragDisabled]="!!photo.hasError"
          aria-label="listing photo"
          class="tm-list-photo-management__item-col"
          role="listitem"
          cdkDrag
          sm="6"
          md="4"
          >
          <tm-list-photo-card
            (activate)="selectPhoto($event)"
            [activatable]="true"
            [photo]="photo"
            attr.aria-label="photo {{ i + 1 }} of {{ photos.length }}"
            tabindex="0"
            >
          </tm-list-photo-card>
        </tg-col>
      }
      @if (photos.length < maxPhotos) {
        <tg-col
          aria-label="file upload area"
          class="tm-list-photo-management__photo-picker-col"
          sm="6"
          md="5"
          lg="4"
          >
          <tg-aspect-ratio
            class="tm-list-photo-management__photo-picker-aspect-ratio"
            ratio="1x1"
            >
            <tm-list-photo-picker
              (photosAreUploading)="onPhotosAreUploading()"
              (photosUploaded)="onPhotosUploaded($event)"
              [isFileReaderApiAvailable]="isFileReaderApiAvailable"
              class="tm-list-photo-management__photo-picker"
              name="photoUploader"
              ngModel
              >
              <tg-drop-zone
                class="tm-list-photo-management__photo-picker-dropzone"
                >
                Browse photos
                <tg-icon alt="add listing photos" name="upload">
                </tg-icon>
                <tg-drop-zone-description>
                  or drag and drop here
                </tg-drop-zone-description>
              </tg-drop-zone>
              <button
                dashed
                disabled="disabled"
                file-upload-disabled
                stackIcon
                tabindex="-1"
                tgbutton2
                transparent
                >
                <tg-icon-left
                  alt="add listing photos"
                  name="upload"
                  tgSize="small"
                  >
                </tg-icon-left>
                <span
                  >Your browser does not support file
                  uploads.</span
                  >
                </button>
              </tm-list-photo-picker>
            </tg-aspect-ratio>
          </tg-col>
        }
      </tg-row>
      <tg-row>
        <tg-col>
          <p class="tm-list-photo-management__photo-info">
            @if (photos.length >= maxPhotos || exceedLimit) {
              <span
                class="tm-list-photo-management__limit-text"
                role="alert"
                >
                You have reached the limit of {{ maxPhotos }} photos.
              </span>
            }
          </p>
        </tg-col>
      </tg-row>
      @if (beNiceAboutPhotoLimit) {
        <tg-row>
          <tg-col>
            <tg-info-box tgStyle="warning">
              <tg-icon name="basic-warning-framed" role="presentation">
              </tg-icon>
              <p>
                You’ve exceeded your limit of {{ maxPhotos }} photos.
                Only the first {{ maxPhotos }} were added.
              </p>
            </tg-info-box>
          </tg-col>
        </tg-row>
      }
      @if (isContainInvalidFile) {
        <tg-row>
          <tg-col>
            <tg-info-box tgStyle="warning">
              <tg-icon name="basic-warning-framed" role="presentation">
              </tg-icon>
              @for (
                error of invalidFilesErrorMessages | keyvalue
                ; track
                error) {
                <p
                  role="alert"
                  >
                  @if (error.value.length > 1) {
                    The following files weren't uploaded{{
                    getErrorDetail(error.key)
                    }}.
                    <ul tgList2 type="bullet" compact>
                      @for (v of error.value; track v) {
                        <li>{{ v }}</li>
                      }
                    </ul>
                  } @else {
                    {{ error.value[0] }} wasn't uploaded{{
                    getErrorDetail(error.key)
                    }}.
                  }
                </p>
              }
            </tg-info-box>
          </tg-col>
        </tg-row>
      }
      <tg-row>
        <tg-col>
          <span class="p-secondary-copy">
            See our
            <a
              class="tm-list-photo-management__help-link h-link-no-visited"
              target="_blank"
              href="https://www.trademe.co.nz/help/popup.aspx?help_id=814&rfm=1"
              >
              photo policy and guidelines
            </a>
          </span>
        </tg-col>
      </tg-row>
      @if (isEditMode()) {
        <tg-modal
          class="tm-list-photo-management__modal"
          required
          stickyFooter
          >
          <tg-modal-header class="tm-list-photo-management__modal-header">
            <h2 class="tm-list-photo-management__modal-heading">
              Edit photos
            </h2>
            <button
              (click)="deselectPhoto()"
              class="tm-list-photo-management__select-photo-button"
              tgButton2
              transparent
              >
              <tg-icon-left name="basic-tick" role="presentation">
              </tg-icon-left>
              Done
              <span class="h-visually-hidden"> editing photos </span>
            </button>
          </tg-modal-header>
          <tg-modal-body class="tm-list-photo-management__modal">
            <tm-list-progress-photo-editor
              #photoEditor
              [(photo)]="editingPhoto"
              class="tm-list-photo-management__photo-editor"
              >
            </tm-list-progress-photo-editor>
          </tg-modal-body>
          <tg-modal-footer class="tm-list-photo-management__modal">
            <div class="tm-list-photo-management__buttons l-container">
              <tg-row>
                <tg-col sm="3">
                  <button
                    (click)="setSelectedPhotoAsMain()"
                                [class.tm-list-photo-management__set-as-main-button--active]="
                                    isSelectedPhotoMain()
                                "
                    class="tm-list-photo-management__set-as-main-button"
                    highlight
                    tgButton2
                    transparent
                    >
                    @if (
                      isSelectedPhotoMain()) {
                      <tg-icon
                        name="star-fill"
                        role="presentation"
                        >
                      </tg-icon>
                    } @else {
                      @if (!isSelectedPhotoMain()) {
                        <tg-icon
                          name="star"
                          role="presentation"
                          >
                        </tg-icon>
                      }
                    }
                    <div
                      class="tm-list-photo-management__set-as-main-button-text"
                      >
                      {{
                      isSelectedPhotoMain()
                      ? 'Main photo'
                      : 'Set as main'
                      }}
                    </div>
                  </button>
                </tg-col>
                <tg-col sm="3">
                  <button
                    (click)="rotateSelectedPhoto()"
                    class="tm-list-photo-management__rotate-button"
                    tgButton2
                    transparent
                    >
                    <tg-icon name="edit-rotate" role="presentation">
                    </tg-icon>
                    <div
                      class="tm-list-photo-management__rotate-button-text"
                      >
                      Rotate
                    </div>
                    <span class="h-visually-hidden">
                      this photo
                    </span>
                  </button>
                </tg-col>
                <tg-col sm="3">
                  <button
                    (click)="cropSelectedPhoto()"
                                [class.tm-list-photo-management__crop-button--active]="
                                    showCropBox()
                                "
                    class="tm-list-photo-management__crop-button"
                    tgButton2
                    transparent
                    >
                    <tg-icon name="edit-crop" role="presentation">
                    </tg-icon>
                    <div
                      class="tm-list-photo-management__crop-button-text"
                      >
                      Crop
                    </div>
                    <span class="h-visually-hidden">
                      this photo
                    </span>
                  </button>
                </tg-col>
                <tg-col sm="3">
                  <button
                    (click)="removeSelectedPhoto()"
                    class="tm-list-photo-management__remove-button"
                    tgButton2
                    transparent
                    >
                    <tg-icon name="bin" role="presentation">
                    </tg-icon>
                    <div
                      class="tm-list-photo-management__remove-button-text"
                      >
                      Delete
                    </div>
                    <span class="h-visually-hidden">
                      this photo
                    </span>
                  </button>
                </tg-col>
              </tg-row>
            </div>
          </tg-modal-footer>
        </tg-modal>
      }
    </section>
  </ng-container>
